import React from 'react';

import { usePermission } from '~/shared/hooks/usePermission';

import type { PermissionCheck } from '~/shared/utils/permissions';

interface GuardProps {
  permission: PermissionCheck;
  mode?: 'hide' | 'disable';
  check?: 'any' | 'all';
  children: React.ReactElement;
}

export default function Guard({ permission, mode = 'hide', check = 'any', children }: GuardProps) {
  const hasPermission = usePermission(permission, check);

  if (hasPermission) {
    return children;
  }

  if (mode === 'disable') {
    return React.cloneElement(children, { disabled: true });
  }

  return null;
}
